import IClientApp from "@/interfaces/IClientApp";
import IState from '@/interfaces/IState';
import {ActionContext} from 'vuex';

export default async (context: ActionContext<IState, IState>, clientAppData: IClientApp) => {
    if (!clientAppData) {
        return Promise.reject('Incorrect client app data');
    }
    try {
        const updatedClientApp = await context.dispatch('backendTalker', {
            request: 'client_app_update',
            data: clientAppData
        });
        console.log('updatedClientApp', updatedClientApp)
        if (updatedClientApp.status === 200) {
            return 'success';
        } else {
            return 'error';
        }
    } catch (err) {
        return 'error'
    }
};
